import initCarousel from '../../components/book-carousel';

const loadCarousel = () => {
	const carousel = document.querySelector( '.wp-block-rte-cookbook-carousel' );

	if ( ! carousel ) {
		return;
	}

	const carouselContainer = carousel.querySelector( '.rte-book-carousel' );
	if ( ! carouselContainer ) {
		return;
	}
	initCarousel( carouselContainer );
};

window.addEventListener( 'DOMContentLoaded', loadCarousel );
window.addEventListener( 'altisBlockContentChanged', loadCarousel );

// Enable HMR
if ( module.hot ) {
	module.hot.accept();
}
